export class Enroll {
  public applicationType = 1;
  public college: number;
  public login: string;
  public password: string;
  public lang: number;
  public lastName: string;
  public firstName: string;
  public patronymic: string;
  public email: string;
  public iin: string;
  public professionid = 0;
  public specializationid = 0;
  public studylanguageid = 0;
  public educatedid = 0;
  public paymentformid = 0;
  public department_id = 1;
  public grantType = 0;

  constructor(college, login, password) {
    this.college = college;
    this.login = login;
    this.password = password;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/models/enroll.ts